import React, { useState } from 'react';
import {
  Box,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ProfileForm from '../../components/forms/profile.form';
import ChangePasswordForm from '../../components/forms/change-password.form';

const MyAccountProfilePage: React.FC = () => {
  const [selectedMenu, setSelectedMenu] = useState<number>(0);

  const menuSxProps = {
    borderRadius: 1,
    mb: 1,
    '&.Mui-selected': {
      bgcolor: 'primary.main',
      color: '#fff',
      '&:hover': { bgcolor: 'primary.dark' },
    },
  };
  return (
    <>
      <Box>
        <Box sx={{ width: { sm: '100%', md: '80%' } }}>
          <Typography variant="h1" gutterBottom sx={{ fontWeight: '600' }}>
            My Account
          </Typography>
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 3 }}>
            <Paper
              elevation={2}
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: '#f9f9f9',
                height: '100%',
              }}
            >
              {/* <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold", color: "text.primary" }}>Menu</Typography> */}

              <List>
                <ListItemButton
                  selected={selectedMenu === 0}
                  onClick={() => setSelectedMenu(0)}
                  sx={menuSxProps}
                >
                  <ListItemText primary="Profile" />
                </ListItemButton>
                <ListItemButton
                  selected={selectedMenu === 1}
                  onClick={() => setSelectedMenu(1)}
                  sx={menuSxProps}
                >
                  <ListItemText primary="Change Password" />
                </ListItemButton>
              </List>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, md: 9 }}>
            {selectedMenu === 0 && (
              <Stack direction="column" gap={2}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: 'text.primary' }}>
                  Profile
                </Typography>
                <ProfileForm />
              </Stack>
            )}
            {selectedMenu === 1 && (
              <Stack direction="column" gap={2}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: 'text.primary' }}>
                  Change Password
                </Typography>
                <ChangePasswordForm />
              </Stack>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default MyAccountProfilePage;
